import React from 'react';
import { get } from 'lodash';
import searchQuery from 'query-string';
import { withRouter } from 'react-router-dom';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as backRoute from 'utils/backRoute';

//local dependencies
import {memberDetailsSavingsRetailPrescriptionWidget as MemberDetailsSavingsRetailPrescriptionWidgetView  } from 'ui/views/widgets/memberDetailsSavingsRetailPrescriptionWidget';
import { MemberDetailsSavingsRetailPrescriptionWidgetService } from 'services/memberDetailsSavingsRetailPrescriptionWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import { overlay } from 'modules/overlay';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsSavingsRetailPrescriptionWidget } from 'ui/containers/MemberDetailsSavingsRetailPrescriptionWidget';
 *
 * // render
 * <MemberDetailsSavingsRetailPrescriptionWidget propName='propValue'/>
 */
class _MemberDetailsSavingsRetailPrescriptionWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // Member Detail instance
        this.memberDetailsSavingsRetailPrescriptionWidgetService = new MemberDetailsSavingsRetailPrescriptionWidgetService();

        // start member detail data fetch
        this.memberDetailsSavingsRetailPrescriptionWidgetData();
    }

    async memberDetailsSavingsRetailPrescriptionWidgetData() {
       
        log.debug( 'MemberDetailsSavingsRetailPrescriptionWidgetService.memberDetailsSavingsRetailPrescriptionWidgetData()' );

        // cancel ongoing request
        this.memberDetailsSavingsRetailPrescriptionWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsSavingsRetailPrescriptionWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', value = {}, item = {}, /*selection = []*/ } = {} ) {
        log.debug( 'MemberDetailsSavingsRetailPrescriptionWidget.handleActionClick()'  );

        // get member id
        const memberId = get( this.props, 'requestPayload.context.memberId', null );

        //const prescriptionId = get( item, 'id', null );

        // prepare back-route state payload
        const backRouteState = backRoute.encode( {
            pathname: this.props.location.pathname,
            payload: {
                entitiesActiveTabIndex: this.props.tabIndex,
                memberId: memberId,
            },
        } );

        if( 'column' === type && 'rxNumber' === value.name ) {
            
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                state: { ...backRouteState, memberId: memberId },
                search: searchQuery.stringify( {
                    rxId: item.values.rxNumber
                } )
            } );
            overlay.close();
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsSavingsRetailPrescriptionWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsSavingsRetailPrescriptionWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_MemberDetailsSavingsRetailPrescriptionWidget.displayName = 'MemberDetailsSavingsRetailPrescriptionWidget';

// set default props
_MemberDetailsSavingsRetailPrescriptionWidget.defaultProps = {
    requestPayload: {},
};

// prop types
_MemberDetailsSavingsRetailPrescriptionWidget.propTypes = {};

export const MemberDetailsSavingsRetailPrescriptionWidget = withRouter( _MemberDetailsSavingsRetailPrescriptionWidget );
